"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGapVerticalStyles = exports.createGapStyles = exports.createSizeStyles = exports.createStyles = exports.Cell = void 0;
var react_1 = __importStar(require("react"));
var styles_1 = require("../../styles");
var Grid_1 = require("./Grid");
function Cell(props) {
    var size = props.size, style = props.style, alignSelf = props.alignSelf, flexGrow = props.flexGrow, flexShrink = props.flexShrink, flexBasis = props.flexBasis, xs = props.xs, sm = props.sm, md = props.md, lg = props.lg, xl = props.xl, rest = __rest(props, ["size", "style", "alignSelf", "flexGrow", "flexShrink", "flexBasis", "xs", "sm", "md", "lg", "xl"]);
    var gridProps = react_1.useContext(Grid_1.GridContext) || Grid_1.Grid.defaultProps;
    var gap = gridProps.gap, gapVertical = gridProps.gapVertical;
    var _a = styles_1.useStyles(exports.createStyles, props, gridProps), classes = _a.classes, css = _a.css;
    var sizeClasses = styles_1.useStyles(exports.createSizeStyles, props, gridProps).classes;
    var gapClasses = styles_1.useStyles(exports.createGapStyles, gridProps).classes;
    var gapVerticalClasses = styles_1.useStyles(exports.createGapVerticalStyles, gridProps).classes;
    var className = css(classes.cell, (xs || size) && sizeClasses.xs, sm && sizeClasses.sm, md && sizeClasses.md, lg && sizeClasses.lg, xl && sizeClasses.xl, typeof gap === 'object' && [
        gap.xs && gapClasses.xs,
        gap.sm && gapClasses.sm,
        gap.md && gapClasses.md,
        gap.lg && gapClasses.lg,
        gap.xl && gapClasses.xl,
    ], typeof gapVertical === 'object' && [
        gapVertical.xs && gapVerticalClasses.xs,
        gapVertical.sm && gapVerticalClasses.sm,
        gapVertical.md && gapVerticalClasses.md,
        gapVertical.lg && gapVerticalClasses.lg,
        gapVertical.xl && gapVerticalClasses.xl,
    ], style);
    return react_1.default.createElement("div", __assign({ className: className }, rest));
}
exports.Cell = Cell;
exports.createStyles = function (theme, _a, _b) {
    var alignSelf = _a.alignSelf, flexBasis = _a.flexBasis, flexGrow = _a.flexGrow, flexShrink = _a.flexShrink;
    var gap = _b.gap, gapVertical = _b.gapVertical;
    return ({
        cell: {
            alignSelf: alignSelf,
            flexBasis: flexBasis,
            flexGrow: flexGrow,
            flexShrink: flexShrink,
            paddingLeft: typeof gap === 'number' && gap / 2 + "rem",
            paddingRight: typeof gap === 'number' && gap / 2 + "rem",
            paddingTop: typeof gapVertical === 'number' && gapVertical / 2 + "rem",
            paddingBottom: typeof gapVertical === 'number' && gapVertical / 2 + "rem",
        },
    });
};
exports.createSizeStyles = function (theme, _a) {
    var _b, _c, _d, _e;
    var size = _a.size, xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl;
    return ({
        xs: {
            width: "calc(100% / 12 * " + (xs || size) + ")",
        },
        sm: (_b = {},
            _b[theme.breakpoints.up('sm')] = {
                width: "calc(100% / 12 * " + sm + ")",
            },
            _b),
        md: (_c = {},
            _c[theme.breakpoints.up('md')] = {
                width: "calc(100% / 12 * " + md + ")",
            },
            _c),
        lg: (_d = {},
            _d[theme.breakpoints.up('lg')] = {
                width: "calc(100% / 12 * " + lg + ")",
            },
            _d),
        xl: (_e = {},
            _e[theme.breakpoints.up('xl')] = {
                width: "calc(100% / 12 * " + xl + ")",
            },
            _e),
    });
};
exports.createGapStyles = function (theme, _a) {
    var _b, _c, _d, _e;
    var gap = _a.gap;
    return ({
        xs: {
            paddingLeft: gap.xs / 2 + "rem",
            paddingRight: gap.xs / 2 + "rem",
        },
        sm: (_b = {},
            _b[theme.breakpoints.up('sm')] = {
                paddingLeft: gap.sm / 2 + "rem",
                paddingRight: gap.sm / 2 + "rem",
            },
            _b),
        md: (_c = {},
            _c[theme.breakpoints.up('md')] = {
                paddingLeft: gap.md / 2 + "rem",
                paddingRight: gap.md / 2 + "rem",
            },
            _c),
        lg: (_d = {},
            _d[theme.breakpoints.up('lg')] = {
                paddingLeft: gap.lg / 2 + "rem",
                paddingRight: gap.lg / 2 + "rem",
            },
            _d),
        xl: (_e = {},
            _e[theme.breakpoints.up('xl')] = {
                paddingLeft: gap.xl / 2 + "rem",
                paddingRight: gap.xl / 2 + "rem",
            },
            _e),
    });
};
exports.createGapVerticalStyles = function (theme, _a) {
    var _b, _c, _d, _e;
    var gapVertical = _a.gapVertical;
    return ({
        xs: {
            paddingTop: gapVertical.xs / 2 + "rem",
            paddingBottom: gapVertical.xs / 2 + "rem",
        },
        sm: (_b = {},
            _b[theme.breakpoints.up('sm')] = {
                paddingTop: gapVertical.sm / 2 + "rem",
                paddingBottom: gapVertical.sm / 2 + "rem",
            },
            _b),
        md: (_c = {},
            _c[theme.breakpoints.up('md')] = {
                paddingTop: gapVertical.md / 2 + "rem",
                paddingBottom: gapVertical.md / 2 + "rem",
            },
            _c),
        lg: (_d = {},
            _d[theme.breakpoints.up('lg')] = {
                paddingTop: gapVertical.lg / 2 + "rem",
                paddingBottom: gapVertical.lg / 2 + "rem",
            },
            _d),
        xl: (_e = {},
            _e[theme.breakpoints.up('xl')] = {
                paddingTop: gapVertical.xl / 2 + "rem",
                paddingBottom: gapVertical.xl / 2 + "rem",
            },
            _e),
    });
};
//# sourceMappingURL=Cell.js.map